module.exports = __webpack_public_path__ + "static/media/properties.84962271.jpg";